import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { Helmet } from "react-helmet";
import { Toaster } from "react-hot-toast";
import Footer from "./Footer";
import { getCart } from "../../service/CartService";

const Layout = ({
  children,
  title,
  description,
  keywords,
  author,
  cartItems,
  setCartItems,
  isFooter,
  isNavbar,
  textColor
}) => {

  const calculateTotalQuantity = () => {
    if (Array.isArray(cartItems)) {
      return cartItems.reduce((total, item) => total + (item?.qty || 0), 0);
    }
    return 0;
  };

  const fetchCartItems = async () => {
    const token = sessionStorage.getItem('auth');
    if (!token) {
      setCartItems([]);
      return;
    }
    try {
      const data = await getCart();
      if (Array.isArray(data.data)) {
        setCartItems(data.data);
      } else {
        setCartItems([]);
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
      setCartItems && setCartItems([]);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  return (
    <div>
      {/* ...SEO friendly...*/}
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <title>{title}</title>
      </Helmet>

      {isNavbar && (
        <Navbar showNormalNav={true} cartCount={calculateTotalQuantity()} textColor={textColor} />
      )}
      <main >
        <Toaster />
        {children}
        {isFooter && <Footer showBothDivs={true} />}
      </main>
    </div>
  );
};

Layout.defaultProps = {
  title: "Sandalwood",
  description: "Sandalwood-Har Ghar Chandan",
  keywords: "facial-care, body-care, hair-care",
  author: "@Sandalwood",
  textColor: "black"
};

export default Layout;
